module.exports = __webpack_public_path__ + "img/website-icon.59e6acf8.svg";